// extracted by mini-css-extract-plugin
module.exports = {"AngleArrow":"angle-arrow_AngleArrow__9P6g8","AngleArrow-disabled":"angle-arrow_AngleArrow-disabled__xXj_z","AngleArrow-right":"angle-arrow_AngleArrow-right__eckOv"};